import { useContext } from 'react';
import { SingleOfferStateContext } from './SingleOfferStateProvider';

interface UseQuoteSpecs {
  selectedGuarantees: string[];
  setSelectedGuarantees: (quoteSpecs: string[]) => void;
}

const useQuoteGuarantees = (): UseQuoteSpecs => {
  const singleOfferState = useContext(SingleOfferStateContext);

  return {
    selectedGuarantees: singleOfferState?.selectedGuarantees
      ? singleOfferState.selectedGuarantees
      : [],
    setSelectedGuarantees: singleOfferState?.setSelectedGuarantees
      ? singleOfferState.setSelectedGuarantees
      : () => null,
  };
};

export default useQuoteGuarantees;
